module.exports = __webpack_public_path__ + "409aa6e4.png";